/* Scoped to the dashboard date popover. Layout only; the popover owns the shadow. */
.flare-day-picker {
  width: max-content;
  background: #ffffff;
  color: #344054;
  font-family: Inter, Inter-Regular, system-ui, sans-serif;
  font-size: 13px;
  line-height: 18px;
}

.flare-day-picker * {
  box-sizing: border-box;
}

.flare-day-picker .rdp-root {
  position: relative;
}

.flare-day-picker .rdp-month {
  position: relative;
}

.flare-day-picker .rdp-months {
  display: flex;
}

.flare-day-picker .rdp-nav {
  position: absolute;
  top: 0;
  right: 0;
  height: 32px;
  display: flex;
  align-items: center;
}

.flare-day-picker .rdp-month_caption {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  margin: 0 32px 4px;
  font-size: 13px;
  font-weight: 600;
  color: #101828;
}

.flare-day-picker .rdp-caption_label {
  border: 0;
  background: transparent;
  font: inherit;
  color: inherit;
}

.flare-day-picker .rdp-button_previous,
.flare-day-picker .rdp-button_next {
  position: absolute;
  top: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
  padding: 0;
}

.flare-day-picker .rdp-button_previous {
  left: 0;
}

.flare-day-picker .rdp-button_next {
  right: 0;
}

.flare-day-picker .rdp-button_previous:hover,
.flare-day-picker .rdp-button_next:hover {
  background: #f2f4f7;
}

.flare-day-picker .rdp-chevron {
  fill: #98a2b3;
  width: 16px;
  height: 16px;
}

.flare-day-picker .rdp-month_grid {
  border-collapse: collapse;
}

.flare-day-picker .rdp-weekday {
  width: 36px;
  padding: 4px 0 6px;
  font-size: 11px;
  font-weight: 500;
  color: #98a2b3;
  text-align: center;
}

.flare-day-picker .rdp-day {
  width: 36px;
  height: 36px;
  text-align: center;
  padding: 0;
}

.flare-day-picker .rdp-day_button {
  width: 32px;
  height: 32px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  padding: 0;
}

.flare-day-picker .rdp-day_button:hover {
  background: #f2f4f7;
}

.flare-day-picker .rdp-day_button:focus-visible {
  outline: 1px solid #2563eb;
  outline-offset: 1px;
}

.flare-day-picker .rdp-outside {
  color: #98a2b3;
}

.flare-day-picker .rdp-today:not(.rdp-outside):not(.rdp-range_start):not(.rdp-range_end) .rdp-day_button {
  border-color: #d0d5dd;
}

.flare-day-picker .rdp-selected {
  font-size: 13px;
  font-weight: 600;
}

.flare-day-picker .rdp-range_start {
  background: linear-gradient(90deg, transparent 50%, #dbeafe 50%);
}

.flare-day-picker .rdp-range_end {
  background: linear-gradient(90deg, #dbeafe 50%, transparent 50%);
}

.flare-day-picker .rdp-range_start.rdp-range_end {
  background: transparent;
}

.flare-day-picker .rdp-range_middle {
  background: #dbeafe;
}

.flare-day-picker .rdp-range_start .rdp-day_button,
.flare-day-picker .rdp-range_end .rdp-day_button {
  background: #2563eb;
  color: #ffffff;
  border-color: transparent;
}

.flare-day-picker .rdp-range_start .rdp-day_button:hover,
.flare-day-picker .rdp-range_end .rdp-day_button:hover {
  background: #2563eb;
}

.flare-day-picker .rdp-range_middle .rdp-day_button {
  border-radius: 0;
  background: transparent;
  color: #101828;
}

.flare-day-picker .rdp-range_middle .rdp-day_button:hover {
  background: transparent;
}

.flare-day-picker .rdp-disabled:not(.rdp-selected) {
  opacity: 0.4;
}
